import styled from "styled-components";
import { Container78VW } from "../../../styles/common";
import { neutral1, neutral10, neutral4 } from "../../../css/colors";
import { primaryFontFamily, primaryFontFamilyBold, } from "../../../styles/fontFamilyTypes";
import { media } from "../../../styles/breakpoints";
export const Header = styled.div `
  display: flex;
  justify-content: center;
  .title {
    font-family: ${primaryFontFamilyBold};
    font-size: 26px;
    font-weight: bold;
    line-height: 1.13;
    letter-spacing: 0.52px;
    text-align: center;
    color: ${neutral1};
    @media ${media.xsmall.down} {
      font-size: 16px;
    }
  }
`;
export const DescriptionContainer = styled.div `
  padding: 12px 0px;
  > div {
    padding: 0px;
    font-family: ${primaryFontFamily};
    font-size: 14px;
    line-height: 1.59;
    letter-spacing: 0.22px;
    text-align: center;
    color: ${neutral4};
    @media ${media.medium.down} {
      min-height: 100px;
      font-size: 10px !important;
    }
  }
`;
export const ButtonContainer = styled.div `
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;

  .subscribe {
    font-size: 26px;
    width: 300px;
    height: 64px;
    font-family: ${primaryFontFamilyBold};
    @media ${media.small.down} {
      width: 137px;
      height: 34px;
      font-family: ${primaryFontFamily};
      font-size: 14px;
      font-weight: bold;
      line-height: 1.29;
      letter-spacing: 0.28px;
      color: ${neutral10};
    }
    @media ${media.large.down} {
      width: 193.3px;
      height: 41.2px;
      font-size: 14px;
    }
  }
`;
export const PricePlanWrapper = styled.div `
  border-radius: 3.2px;
  background-color: ${neutral10};
  height: auto;
  width: 100%;
  margin: 0px 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media ${media.xsmall.down} {
    margin: 0px 4px;
    padding: 16px 6px;
    width: 48%;
  }
`;
export const Container = styled(Container78VW) `
  display: flex;
  flex-direction: row;
  max-width: 63.5vw;
  padding: 50px 60px 60px 60px;
  position: absolute;
  left: 0;
  right: 0;
  margin-top: -330px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  z-index: 1;
  overflow-x: scroll;
  justify-content: center;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
  }
  > div:first-child {
    margin-left: 0px;
  }
  > div:last-child {
    margin-right: 0px;
  }

  @media ${media.small.down} {
    display: none;
  }
`;

